// extracted by mini-css-extract-plugin
module.exports = {"green":"#3c9867","blue":"#257ac9","red":"#e23e3e","light-primary":"#fff","light-secondary":"#f4f5f7","dark-primary":"#253134","dark-secondary":"#303d45"};